<template>
    <div :id="this.$route.name">
        <card back>
            <template v-slot:header>
                <h4 class="d-inline">اطلاعات ماهیانه کارگاه</h4>
                <hr />
            </template>
            <template v-slot:btnCustome>
                <button class="bg-success float-left btn no-print mx-2 text-light Pointer" @click="downloadDsk()"> تهیه دسکت</button>
            </template>
            <template v-slot:content>
                <div class="d-flex justify-content-between mb-2">
                    <div>
                        <p> اطلاعات ماهیانه کارگاه </p>
                    </div>
                    <!-- <a class="btn btn-success" @click="downloadDsk()">دریافت فایل های اطلاعات کارگاه و بیمه شدگان</a> -->
                </div>
                <div class="row">
                    <div class="col-md-3 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> بیمه : </small>[ {{ DataAxois.Bime }} ]
                        </div>
                    </div>
                    <div class="col-md-3 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> کد کارگاه : </small>[ {{ DataAxois.WorkShopCode }} ]
                        </div>
                    </div>
                    <div class="col-md-3 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> نام کارگاه : </small>[ {{ DataAxois.WorkShopName }} ]
                        </div>
                    </div>
                    <div class="col-md-3 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> نام کارفرما : </small>[ {{ DataAxois.Boss }} ]
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> ردیف پیمان : </small>[ {{ DataAxois.PeymanRow }} ]
                        </div>
                    </div>
                    <div class="col-md-3 col-12 ">
                        <div class="mt-2 form-inline">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> شماره لیست : </small>
                            <input type="text" style="width: 13%;" dir="ltr" @keypress="$ValidNumber($event, 2)"
                                class="form-control text-center " v-model="ShomareList" />

                        </div>
                    </div>
                    <div class="col-md-3 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> تعداد نفرات : </small>[ {{ DataAxois.PersonelCount }} ]
                        </div>
                    </div>
                    <div class="col-md-3 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> جمع روزهای کارکرد : </small>[ {{
                                DataAxois.SumWorkPerformanceDaily }} ]
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <hr style="border-top: dotted 1px;" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> جمع دستمزد روزانه : </small>[ {{ $Comma3ragham(
                                DataAxois.SumDailySalary) }} ]
                        </div>
                    </div>
                    <div class="col-md-4 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> جمع مزایای ماهانه مشمول : </small>[ {{ $Comma3ragham(
                                DataAxois.Benefits) }} ]
                        </div>
                    </div>
                    <div class="col-md-4 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> حق بیمه سهم بیمه‌شده : </small>[ {{
                                $Comma3ragham(DataAxois.BimeSahmeBimeShode) }} ]
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-4 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> جمع دستمزد ماهانه : </small>[ {{
                                $Comma3ragham(DataAxois.SumMonthlySalary) }} ]
                        </div>
                    </div>
                    <div class="col-md-4 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> جمع دستمزد و مزایای ماهانه مشمول : </small>[ {{ $Comma3ragham(
                                DataAxois.SumSalaryAndBenefitsBime) }} ]
                        </div>
                    </div>
                    <div class="col-md-4 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> حق بیمه سهم کارفرما : </small>[ {{
                                $Comma3ragham(DataAxois.BimeSahmeKarfarma) }} ]
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-4 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> نرخ حق بیمه : </small>[ {{ DataAxois.InsFee }} ]
                        </div>
                    </div>
                    <div class="col-md-4 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> جمع کل دستمزد و مزایای ماهانه : </small>[ {{ $Comma3ragham(
                                DataAxois.SumSalaryAndBenefits) }} ]
                        </div>
                    </div>
                    <div class="col-md-4 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;"> حق بیمه بیکاری : </small>[ {{
                                $Comma3ragham(DataAxois.BimeBikary) }} ]
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-12">
                        <hr style="border-top: dotted 1px;" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-12 ">
                        <div class="mt-2">
                            <i class="fad fa-list-ul" style="color: var(--logo-color) !important"></i> &nbsp;
                            <small style="font-size: 16px;">مبلغ فیش پرداخت حق بیمه : </small>[ {{
                                $Comma3ragham(DataAxois.FishBime) }} ]
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <hr style="border-top: dotted 1px;" />
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-12 text-center">
                        اطلاعات ماهیانه بیمه شدگان
                    </div>
                </div>
                <BnpGrid v-if="$store.state.renderComponentGrid" :propsColumn="Column" :propsRows="rows" :hasRowNum="true"
                    :Sortable="true">
                </BnpGrid>
            </template>
        </card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
    data() {
        return {
            rows: [],
            Column: [
                {
                    name: 'Id',
                    label: 'Id',
                    visibility: false,
                },
                {
                    name: 'NamFam',
                    label: 'پرسنل',
                    visibility: true,
                },
                {
                    name: 'WorkPerformanceDaily',
                    label: 'کارکرد',
                    visibility: true,
                },
                {
                    name: 'DailySalary',
                    label: 'دستمزد روزانه',
                    visibility: true,
                },
                {
                    name: 'SalaryBasic',
                    label: 'دستمزد ماهانه',
                    visibility: true,
                },
                {
                    name: 'BanfitsBime',
                    label: 'مزایای مشمول',
                    visibility: true,
                },
                {
                    name: 'SalaryAndBenfitsBime',
                    label: 'جمع حقوق و مزایای مشمول',
                    visibility: true,
                },
                {
                    name: 'SalaryAndBenfits',
                    label: 'جمع کل',
                    visibility: true,
                },
                {
                    name: 'HagheBime',
                    label: 'حق بیمه',
                    visibility: true,
                },

            ],
            SalaryId: 0,
            DataAxois: {},
            ShomareList: 1
        }
    },
    components: { Card, BnpGrid },
    beforeMount() {
        this.SalaryId = this.$route.query.SalaryId
    },
    mounted() {

        this.GetData()
    },
    methods: {
        GetData() {
            var DataAxois = {
                ArryfildValue: {}, Method: 'Get', Action: 'SalaryReport/GetInsuranceDiskette/' + this.SalaryId, Token: this.$session.get('Token'),
            }
            this.$PostData(DataAxois).then((data) => {
                if (data != null) {
                    if (data.IsSuccess == true) {
                        console.log(data);
                        this.DataAxois = data.Data
                        for (let index = 0; index < data.Data.Personels.length; index++) {
                            const element = data.Data.Personels[index];
                            this.rows.push(element)
                        }
                    }
                }
            }).finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true
                })
            });
        },
        GetDisketBime(){
            var DataAxois = {
                ArryfildValue: {}, Method: 'Get', Action: 'SalaryReport/GetDisketBime/' + this.SalaryId+'/'+1, Token: this.$session.get('Token'),
            }

            this.$PostData(DataAxois).then((data) => {
                if (data != null) {
                    if (data.IsSuccess == true) {
                        console.log(data.Data.WorkShopDisketVM);
                        // var e = window.URL.createObjectURL(new Blob([JSON.stringify(data.Data.WorkShopDisketVM)])), link = document.createElement("a");
                        // link.href = e,
                        // link.setAttribute("download", "DSKKAR00.DBF"),
                        // document.body.appendChild(link),
                        // link.click(),
                        // link.remove()
                    }
                }
            })
        },
        GetPrint() {
            var mywindow = window.open('', 'PRINT')
            mywindow.document.write('<html><head>')
            mywindow.document.write('<link rel="stylesheet" href="/assets/bootstrap/bootstrap.min.css"  >')
            mywindow.document.write('<link rel="stylesheet" href="/assets/iransans/font-face-Sans.css">')
            mywindow.document.write('<link rel="stylesheet" href="/assets/print/FishPrint.css">')
            mywindow.document.write('</head><body onload="window.print()" dir="rtl">')
            mywindow.document.write(document.getElementById('printableArea').innerHTML)
            mywindow.document.write('</body></html>')
            mywindow.document.close()
            mywindow.focus()
            mywindow.document.close()
        },

        downloadDsk() {
            var DataAxois = {
                ArryfildValue: {}, Method: 'Get', Action: 'SalaryReport/GetDisketsBime/' + this.SalaryId + "/" + this.ShomareList,
            }
            this.$PostData(DataAxois).then((data) => {
                if (data.IsSuccess == true) {
                    this.saveBase64ToFile(data.Data.workShopDisket, "DSKKAR00")
                    this.saveBase64ToFile(data.Data.personelDisket, "DSKWOR00")
                } else {
                    this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
                }
            }).catch((err) => {
                console.log(err)
                this.$mySweetDefaultTost('', 'خطای سمت سرور', 'error', 3000)
            })
        },

        saveBase64ToFile(base64Content, fileName) {
            const a = document.createElement("a");
            a.href = `data:application/octet-stream;base64,${base64Content}`;
            a.download = fileName + '.dbf';
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }
}
</script>
<style scoped></style>